// @flow
/**
 * Merge widget preset props into a slot component's props.
 * Preserves internal deploy-time props (e.g. CustomWidget _resolvedData).
 */
export default function applyWidgetPreset(
  componentProps: Object,
  presetId: ?string,
  widgetPresets: Array<{ _id: string | { toString: () => string }, props: Object }> = []
): Object {
  const props = componentProps || {};

  if (!presetId) {
    return props;
  }

  const presets = widgetPresets || [];
  const preset = presets.find(
    p => p._id.toString() === presetId.toString()
  );

  if (!preset) {
    console.warn(
      `Tried to load component with preset ${presetId} but no preset was found. ` +
      'Rendering with component props instead.'
    );
    return props;
  }

  const internalProps = {};
  if (props._resolvedData) {
    internalProps._resolvedData = props._resolvedData;
  }

  return {
    ...preset.props,
    ...internalProps
  };
}
